import React from 'react'
import PropTypes from 'prop-types'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import { format } from '@morningtrain/helpers'

function DenominationCurrency (props) {
  const { name, defaultValue, denomination, maxDecimals, minDecimals, currency } = props

  let value = useValue(name, defaultValue)

  if (!(typeof value === 'number')) {
    value = parseFloat(value)
  }

  if (isNaN(value)) {
    return null
  }

  return format.moneyFormat(value / denomination, maxDecimals, minDecimals, currency)
}

DenominationCurrency.defaultProps = {
  defaultValue: null,
  denomination: 100,
  maxDecimals: 2,
  minDecimals: 2,
  currency: 'DKK'
}

DenominationCurrency.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  denomination: PropTypes.number,
  maxDecimals: PropTypes.number,
  minDecimals: PropTypes.number,
  currency: PropTypes.node
}

export default observer(DenominationCurrency)
